import { render, staticRenderFns } from "./onClick-editor.vue?vue&type=template&id=65965193&scoped=true&"
import script from "./onClick-editor.vue?vue&type=script&lang=js&"
export * from "./onClick-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65965193",
  null
  
)

export default component.exports